var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.store === 0
      ? _c(
          "div",
          [
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("common.security.pem"),
                  isTitleUpperCase: false,
                },
              },
              [
                _c(
                  "b-row",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "4" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("common.security.name"),
                            placeholderValue: _vm.$t("common.security.name"),
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("common.security.certificate"),
                  isTitleUpperCase: false,
                },
              },
              [
                _c("app-button", {
                  attrs: {
                    text: _vm.$t("common.security.add_certificat"),
                    icon: "fa-light fa-plus",
                    variant: "secondary",
                    "custom-class": "mb-5",
                  },
                  on: { click: _vm.addCertificat },
                }),
                _vm._v(" "),
                _vm._l(_vm.certificatList, function (certificat, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "rounded p-4 trackingAccordion mb-5",
                    },
                    [
                      certificat.certificate !== null
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-start align-items-center form-group",
                            },
                            [
                              certificat.certificate === ""
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group mb-5",
                                      attrs: { sm: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "filter-item-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "common.security.certificat_file"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "color-red" }, [
                                        _vm._v("* "),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-textarea", {
                                        staticStyle: { "max-height": "none" },
                                        attrs: {
                                          id: "textarea",
                                          placeholder: _vm.$t(
                                            "common.enter_something"
                                          ),
                                          rows: "6",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.processCertificat(
                                              certificat
                                            )
                                          },
                                        },
                                        model: {
                                          value: certificat.certificate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              certificat,
                                              "certificate",
                                              $$v
                                            )
                                          },
                                          expression: "certificat.certificate",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              certificat.certificate !== ""
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group mb-5",
                                      attrs: { sm: "12" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "filter-item-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "common.security.certificat_file"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "color-red" }, [
                                        _vm._v("* "),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-textarea", {
                                        staticStyle: { "max-height": "none" },
                                        attrs: {
                                          id: "textarea",
                                          placeholder: _vm.$t(
                                            "common.enter_something"
                                          ),
                                          rows: "6",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.processCertificat(
                                              certificat
                                            )
                                          },
                                        },
                                        model: {
                                          value: certificat.certificate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              certificat,
                                              "certificate",
                                              $$v
                                            )
                                          },
                                          expression: "certificat.certificate",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              certificat.certificate === ""
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "form-group d-flex flex-column mb-5",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "filter-item-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "common.security.certificat_file"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "color-red" },
                                          [_vm._v("* ")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: { type: "file", accept: ".pem" },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleFileUploadCertificat(
                                              $event,
                                              index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              certificat.certificate == ""
                                ? _c("b-col", {
                                    staticClass: "form-group",
                                    attrs: { sm: "4" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "d-flex align-items-center form-group" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "4" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("common.security.name"),
                                  placeholderValue: _vm.$t(
                                    "common.security.name"
                                  ),
                                },
                                model: {
                                  value: certificat.name,
                                  callback: function ($$v) {
                                    _vm.$set(certificat, "name", $$v)
                                  },
                                  expression: "certificat.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "4" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: certificat.startDate,
                                  inputLabel: _vm.$t(
                                    "common.security.startDate"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.startDate"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "4" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: certificat.endDate,
                                  inputLabel: _vm.$t("common.security.endDate"),
                                  placeholderValue: _vm.$t(
                                    "common.security.endDate"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", {
                            staticClass: "form-group mb-5",
                            attrs: { sm: "2" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "d-flex align-items-center form-group" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "4" } },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: certificat.deliveredBy,
                                  inputLabel: _vm.$t(
                                    "common.security.deliveredBy"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.deliveredBy"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "4" } },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: certificat.deliveredTo,
                                  inputLabel: _vm.$t(
                                    "common.security.deliveredTo"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.deliveredTo"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", {
                            staticClass: "form-group",
                            attrs: { sm: "4" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("app-button", {
                        attrs: {
                          text: _vm.$t("common.security.remove_certificat"),
                          icon: "fa-light fa-trash",
                          variant: "secondary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeCertificat(index, certificat)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }